<template>
  <div>
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-container grid-list-lg>
        <v-subheader> All Categories </v-subheader>
        <v-layout wrap>
          <v-flex
            v-for="category in categories"
            :key="`category-` + category.id"
            xs2
            class="hidden-sm-and-down"
          >
            <v-card :to="'/category/' + category.slug" class="mx-auto">
              <v-img
                :src="getImage('/' + category.image)"
                class="red--text"
                height="200px"
                width="200px"
              >
              </v-img>
              <v-card-text
                style="height: 80px; overflow: hidden"
                class="fill-height align-end"
                v-text="category.name"
              ></v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            v-for="category in categories"
            :key="`category-` + category.id"
            xs6
            class="hidden-sm-and-up"
          >
            <v-card :to="'/category/' + category.slug" class="mx-auto">
              <v-img
                :src="getImage('/' + category.image)"
                class="red--text"
                height="200px"
                width="200px"
              >
              </v-img>
              <v-card-text
                style="height: 80px; overflow: hidden"
                class="fill-height align-end"
                v-text="category.name"
              ></v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <template>
        <div class="text-center">
          <v-pagination
            v-model="page"
            @input="go"
            :length="lengthPage"
            :total-visible="5"
          ></v-pagination>
        </div>
      </template>
    </v-card>
  </div>
</template>
<script>
export default {
  data: () => ({
    categories: [],
    page: 0,
    lengthPage: 0,
  }),
  created() {
    this.go();
  },
  methods: {
    go() {
      let url = "/ecommerce-categories?page=" + this.page;
      this.axios
        .get(url)
        .then((response) => {
          let { data } = response.data;
          let { meta } = response.data;
          this.categories = data;
          // jumlah halaman di dapat dari meta endpoint categories
          this.lengthPage = meta.last_page;
          this.page = meta.current_page;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
  },
};
</script>
